<template>
<sweet-modal ref="edit_doc_modal" v-if="$parent.dataReady == true">
  <!-- v-on:close="resetEditor" -->
  <!-- <h2>{{e_doc_new == true ? $t('new_doc') : $t('edit') }}</h2> -->

  <div class="row">

    <div class="form-group col-md-2" v-if="e_doc.isNew == true">
      <label for="e_doc_at">{{$t('date')}}</label>
      <datetime v-model="e_doc.at" name="e_doc_at" format="dd/LL/yyyy" auto="true"></datetime>
    </div>

    <div class="form-group col-md-4" v-if="e_doc.isNew == true">
      <label for="e_doc_accounting_ref">{{$t('customer')}}</label>
      <v-select id="e_doc_client_id_processing" dir="rtl" v-model="e_doc.client_id_processing" label="label" :filterable="false"
        :options="clients_options" @search="onClientSearch">
        <template slot="no-options">
          {{$t('type_to_search')}}..
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.label }}
          </div>
        </template>
        <template slot="selected-option" scope="option">
          <div class="selected d-center">
            {{ option.label }}
          </div>
        </template>
      </v-select>
    </div>

    <div class="col-md-3" v-if="e_doc.isNew == false">
      <div>{{$t('date')}}:
        <span dir="ltr">{{ $moment(e_doc.at).format('DD/MM/YYYY - HH:mm') }}</span>
      </div>
      <div>{{$t('client')}}: {{e_doc.client.name}}</div>

    </div>

    <div class="form-group col-md-2">
      <label for="e_doc_accounting_ref">{{$t('accounting_ref')}}</label>
      <input id="e_doc_accounting_ref" v-model="e_doc.accounting_ref" placeholder="" class="form-control">
    </div>

    <div class="form-group col-md-3">
      <label for="e_doc_notes">{{$t('notes')}}</label>
      <input id="e_doc_notes" v-model="e_doc.notes" placeholder="" class="form-control">
    </div>



    <div class="form-group col-md-1" v-if="e_doc.isNew == false">
      <label for="e_doc_discount_rate">{{$t('discount_rate')}}</label>
      <input id="e_doc_discount_rate" @input="calculate_discount" v-model="e_doc.discount_rate" placeholder="" class="form-control"
        :disabled="discount_disabled">
    </div>

    <div class="form-group col-md-1" v-if="e_doc.isNew == false">
      <label for="e_doc_total_base">{{$t('before_discount')}}</label>
      <input id="e_doc_total_base" v-model="e_doc.total_base" placeholder="" class="form-control" disabled="true">
    </div>

    <div class="form-group col-md-1" v-if="e_doc.isNew == false">
      <label for="e_doc_price">{{$t('total')}}</label>
      <!-- <input id="e_doc_price" v-on:keyup.40="freeze_total" v-model="e_doc.total" placeholder="" class="form-control"  disabled="true" > -->
      &nbsp;
      <p>{{parseFloat(e_doc.total).toFixed(2)}}</p>


    </div>

  </div>

  <div class="form-group ">
    <h2>{{$t('itemlines')}}</h2>
    <table style="width: 100%; ">
      <thead v-if="e_doc.itemlines && e_doc.itemlines.length> 0">
        <tr class="row">
          <th class="col-md-5">{{$t('name')}}</th>
          <th class="col-md-2">{{$t('notes')}}</th>
          <th class="col-md-1">{{$t('quantity')}}</th>
          <!-- <th class="col-md-1">{{$t('cost')}}</th> -->
          <th class="col-md-1">{{$t('price')}}</th>
          <th class="col-md-1">{{$t('total')}}</th>

          <th class="col-md-1"></th>
        </tr>
      </thead>
      <tbody v-if="e_doc.itemlines && e_doc.itemlines.length > 0">
        <tr v-for="(itemline, index) in e_doc.itemlines" v-if="itemline.delete !== true" class="row">
          <td v-if="itemline.item.id === null" class="col-md-5" v-tooltip.top-start="{content: itemInfo(itemline.item_id_processing), classes: ['itemline_tooltip']}">
            <v-select dir="rtl" @input="set_item_data(itemline._serial, $event)" v-model="itemline.item_id_processing" label="label"
              :filterable="false" :options="items_options" @search="onItemSearch">
              <template slot="no-options">
                {{$t('type_to_search')}}..
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.label }}
                </div>
              </template>
              <template slot="selected-option" scope="option">
                <div class="selected d-center">
                  {{ option.label }}
                </div>
              </template>
            </v-select>
          </td>
          <td class="col-md-5" v-else>
            <span>({{itemline.item.sku}}) </span>
            <span v-if="itemline.item.barcode != ''">[{{itemline.item.barcode}}] </span>{{itemline.item.name}}</td>
          <td class="col-md-2">
            <input class="form-control" v-model="itemline.notes">
          </td>

          <td class="col-md-1">
            <input class="form-control" v-model="itemline.quantity">
          </td>

          <!-- <td class="col-md-1" >{{itemline.cost}}</td> -->

          <td class="col-md-1">
            <input class="form-control" v-model="itemline.price">
          </td>

          <td class="col-md-1">
            <div style="margin-top: 5pt;">
              {{itemline.line_total}}
            </div>



          </td>
          <td class="col-md-1">
            <button class="btn btn-danger" @click="deleteItemline(index)">
              {{$t('delete')}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-info" @click="addItemline">{{$t('add_itemline')}}</button>
  </div>


  <div class="form-group">
    <button class='btn btn-success' v-on:click="save_doc">{{$t('save')}}</button>
  </div>
</sweet-modal>
</template>

<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash'
Vue.use(VueLodash)

import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
export default {
  components: {
    SweetModal,
    SweetModalTab
  },
  props: ['e_doc'],
  data() {
    return {
      e_doc_new: false,
      clients_options: [],
      lineitem_serial: 0,
      items_options: [],
      discount_disabled: false
    }
  },
  created() {},
  mounted() {},
  watch: {
    'e_doc.itemlines': {
      handler: function(o, newValue) {
        this.e_doc.discount_rate = 0
        this.discount_disabled = true
        newValue.forEach(function(lineitem, index) {
          if (this[index].item_id_processing === null) {
            this[index].item_id_processing = { value: null, label: null, calc_vat: false, cost: 0 }
            this[index].quantity = 0
            this[index].price = 0
            this[index].total = 0
          }

          this[index].line_total = (this[index].price * this[index].quantity).toFixed(2).replace(/\.0+$/, '')
        }, newValue) // use arr as this
      },
      deep: true
    }
  },
  methods: {
    freeze_total: function() {},
    calculate_discount: function() {
      let discount_rate = this.e_doc.discount_rate / 100

      this.e_doc.total = this.e_doc.total_base - this.e_doc.total_base * discount_rate

      let price_inc_vat = this.e_doc.total * 0.17 + this.e_doc.total

      console.log(price_inc_vat)

      let total_without_vat_rounded = (Math.floor(price_inc_vat) / 117) * 100
      this.e_doc.total_inc_vat = Math.floor(price_inc_vat)
      this.e_doc.total = total_without_vat_rounded

      //this.e_doc.total = Math.floor(this.e_doc.total_base - this.e_doc.total_base * discount_rate)
    },
    set_item_data: function(serial, obj) {
      for (var i in this.e_doc.itemlines) {
        if (this.e_doc.itemlines[i]._serial == serial) {
          this.e_doc.itemlines[i].price = obj.price
          this.e_doc.itemlines[i].cost = obj.cost
        }
      }
    },
    onItemSearch(search, loading) {
      loading(true)
      this.getItemsbyAutocomplete(loading, search, this)
    },

    getItemsbyAutocomplete: Vue._.debounce((loading, search, vm) => {
      fetch(`/api/items/autocomplete?query=${search}`, { headers: vm.authorization() }).then(res => {
        res.json().then(json => (vm.items_options = json.items))
        loading(false)
      })
    }, 350),

    onClientSearch(search, loading) {
      loading(true)
      this.getClientsbyAutocomplete(loading, search, this)
    },
    getClientsbyAutocomplete: Vue._.debounce((loading, search, vm) => {
      fetch(`/api/clients/autocomplete?query=${search}`, { headers: vm.authorization() }).then(res => {
        res.json().then(json => (vm.clients_options = json.clients))
        loading(false)
      })
    }, 350),

    addItemline: function() {
      this.lineitem_serial++

      this.e_doc.itemlines.push({
        quantity: 1,
        price: 0,
        notes: null,
        item: { id: null },
        item_id_processing: { value: null, label: null, cost: 0, price: 0 },
        delete: false,
        item_id: null,
        line_total: 0,
        cost: null,
        _serial: this.lineitem_serial
      })
    },
    deleteItemline: function(index) {
      this.e_doc.itemlines[index].delete = true
    },

    itemInfo: function(item_data) {
      console.log(item_data)
      return typeof item_data.sku !== 'undefined'
        ? `
      <div dir="ltr" style='text-align:left;'>${item_data.sku}</div>
      <div dir="${this.hasUnicode(item_data.item_name) ? 'rtl' : 'ltr'}" style='text-align:${
            this.hasUnicode(item_data.item_name) ? 'right' : 'left'
          };'>
      ${item_data.item_name}
      </div>
      <div dir="rtl" style='text-align:right;'>${item_data.vendor_name}</div>
      `
        : null
    },
    save_doc: function() {
      console.log(this.e_doc)
      this.e_doc.isNew == true ? this.create_doc() : this.update_doc()
    },
    create_doc: function() {
      console.log('create_doc..')
      let vm = this
      let doc = vm.pre_process_doc(vm.e_doc)
      doc.doctype_id = vm.$parent.doctype
      console.log(doc)

      this.$axios
        .post(
          `/api/docs`,
          {
            doc
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          console.log(response)
          vm.$refs.edit_doc_modal.close()
          // this.resetEditor()
          vm.$parent.e_doc = vm.$parent.init_doc()
          vm.$parent.loadDocs()
        })
        .catch(e => {
          vm.errors.push(e)
          vm.PageSelectisDisabled = false
        })
    },

    update_doc: function() {
      console.log('update_doc..')

      let vm = this
      vm.$parent.dataReady = false
      let adjusted_itemlines = []
      let doc = vm.e_doc

      doc.itemlines.filter(function(value, key) {
        if (value.item_id_processing !== null && typeof value.item_id_processing === 'object') {
          value.item_id = value.item.id === null ? value.item_id_processing.value : value.item_id
          value.cost = value.cost === null ? value.item_id_processing.cost : value.cost
        }

        if (value.item_id) {
          adjusted_itemlines.push(value)
        }
      })

      doc.itemlines = adjusted_itemlines

      this.$axios
        .put(
          `/api/docs/` + doc.id,
          {
            doc
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          vm.$parent.loadDoc()
          vm.$refs.edit_doc_modal.close()
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },
    pre_process_doc: function(doc) {
      var adjusted_itemlines = []
      var pre_processed_doc = JSON.parse(JSON.stringify(doc))

      if (pre_processed_doc.isNew == true) {
        pre_processed_doc.discount_rate = 0
      }

      pre_processed_doc.itemlines.filter(function(value, key) {
        if (value.item_id_processing !== null && typeof value.item_id_processing === 'object') {
          value.item_id = value.item_id_processing.value
          value.cost = value.item_id_processing.cost
        }
        delete value.item_id_processing

        if (value.delete !== true) {
          adjusted_itemlines.push(value)
        }
      })

      pre_processed_doc.itemlines = adjusted_itemlines
      pre_processed_doc.client_id = doc.client_id_processing.value
      delete pre_processed_doc.client_id_processing
      return pre_processed_doc
    }
  }
}
/*
    save_entity: function() {
      var vm = this
      var doc = this.e_doc
      if (e_doc.id == null) {
        vm.create_entity()
        return
      }
      this.$axios
        .put(
          `/api/doc/` + e_doc.id,
          {
            doc
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          console.log(response)
          vm.$refs.edit_book_modal.close()
          this.loadDocs()
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },
   
    create_entity: function() {
      var vm = this
      var doc = this.e_doc
      doc.doctype = 
      this.$axios
        .post(`/api/docs`, {
          doc
        })
        .then(response => {
          if (response.status == 201) {
            this.flash(this.$t('doc_added_successfully'), 'success')
          }
        })
        .catch(function(error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data)
            console.log(error.response.status)
            console.log(error.response.headers)
          } else if (error.request) {
            console.log(error.request)
          } else {
            console.log('Error', error.message)
          }
          console.log(error.config)
          //this.errors.push(error)
        })
    },
     */
</script>

